<template>
    <v-container fluid class="pa-4">
        <v-row justify="center">
            <v-col cols="12" xl="10" lg="11">
                <v-card :loading="loading">
                    <v-toolbar color="grey-lighten-4" density="comfortable">
                        <v-toolbar-title> {{ title }} </v-toolbar-title>
                        <v-spacer />
                        <v-btn icon="mdi-close" variant="text" @click="cancel" />
                    </v-toolbar>

                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.ticketType" :items="ticketTypeItems" item-title="label"
                                    item-value="value" clearable>
                                    <template #label> Type ticket <span class="text-red">*</span> </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.ticketStatus" :items="ticketStatusItems"
                                    item-title="label" item-value="value" clearable>
                                    <template #label> Status <span class="text-red">*</span> </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.assigneeId" :items="users" item-title="fullName"
                                    item-value="id" clearable>
                                    <template #label> Assigné à <span class="text-red">*</span> </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field v-model="form.creationDate" type="date" label="Date de création" readonly>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field v-model="form.modificationDate" type="date" label="Date de modification" readonly>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.creatorId" :items="users" label="Créé par" item-title="fullName"
                                    item-value="id" readonly>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field v-model="form.caller" clearable>
                                    <template #label>Nom du client<span class="text-red">*</span> </template>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.callerType" :items="clientTypes" item-title="label"
                                    item-value="value" clearable>
                                    <template #label> Type du client <span class="text-red">*</span> </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field v-model="form.clientCompany" label="Société du client" clearable>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.contactType" :items="contactTypes" item-title="label"
                                    item-value="value" clearable>
                                    <template #label> Type de contact <span class="text-red">*</span> </template>
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="12" md="4">
                                <v-text-field v-model="form.telephone" clearable>
                                    <template #label> Téléphone du client <span class="text-red">*</span> </template>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field v-model="form.email" clearable>
                                    <template #label> Email du client <span class="text-red">*</span> </template>
                                </v-text-field>
                            </v-col>


                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.laverieId" :items="laveries" item-title="numeroDeContrat"
                                    item-value="id" clearable>
                                    <template #label>Laverie<span class="text-red">*</span> </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.productId" :items="concernedProducts" item-title="title"
                                    item-value="id" label="Produit concerné" clearable>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.concernedService" :items="concernedServiceItems"
                                    item-title="label" item-value="value" clearable>
                                    <template #label> Service concerné <span class="text-red">*</span> </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field :model-value="selectedLaverie?.name ?? ''" label="Nom de la laverie"
                                    readonly>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field :model-value="selectedLaverie?.address?.ville ?? ''"
                                    label="Ville de la laverie" readonly>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field :model-value="selectedLaverie?.address?.codepostale ?? ''"
                                    label="Code postal de la laverie" readonly>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.productIsPluggedIn" :items="booleanItems"
                                    item-title="label" item-value="value" label="La machine est branchée ?" clearable />
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.drumTurns" :items="booleanItems" item-title="label"
                                    item-value="value" label="Le tambour tourne ?" clearable />
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete v-model="form.coinSlotTakesCoins" :items="booleanItems"
                                    item-title="label" item-value="value" label="Le monnayeur prend des pièces ?"
                                    clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.errorCode" label="Code d'erreur machine" clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.centralErrorCode" label="Code d'erreur de la centrale"
                                    clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-autocomplete v-model="form.waterStatus" :items="waterStatusItems" item-title="label"
                                    item-value="value" label="État de l'eau" clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-autocomplete v-model="form.tapsStatus" :items="tapsStatusItems" item-title="label"
                                    item-value="value" label="État des robinets" clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.residenceName" label="Nom de la résidence" clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.buildingNumber" label="Numéro de bâtiment" clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.city" label="Ville" clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.postalCode" label="Code postal" clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.roomOrApartmentNumber"
                                    label="Numéro de chambre ou d'appartement" clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field v-model="form.paymentCardLast4Digits"
                                    label="Derniers chiffres de la carte de paiement" clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field type="date" v-model="form.paymentDate" label="Date de paiement"
                                    clearable />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field type="time" v-model="form.paymentTime" label="Heure de paiement"
                                    clearable />
                            </v-col>

                            <v-col cols="12">
                                <v-textarea v-model="form.description" rows="3" clearable>
                                    <template #label> Descriptif de la demande <span class="text-red">*</span>
                                    </template>
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider />
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" variant="flat" @click="save">Enregistrer</v-btn>
                        <v-btn color="primary" variant="flat" @click="cancel">Annuler</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAppStore } from "@/store/app";
import { useSessionStore } from "@/store/session";
import {
    SupportTicket,
    SupportTicketCallerType,
    SupportTicketConcernedService,
    SupportTicketContactType,
    SupportTicketStatus,
    SupportTicketTapsStatus,
    SupportTicketType,
    SupportTicketWaterStatus,
} from "@/types";
import { getAllLaveries } from "@/utils/laverie-api";
import { getProductsByLaverieId } from "@/utils/product-api";
import {
    fetchSupportTicketById,
    postSupportTicket,
    putSupportTicket,
} from "@/utils/support-ticket-api";

import type { Product, Laverie, User } from "@/types";
import { getAllUsers } from "@/utils/user-api";

const router = useRouter();
const route = useRoute();
const appStore = useAppStore();
const sessionStore = useSessionStore();

const loading = ref(false);
const ticketId = ref<string | null>(null);
const laveries = ref<Laverie[]>([]);
const users = ref<User[]>([]);
const concernedProducts = ref<Product[]>([]);
const title = ref("");

const form = ref<SupportTicket>({
    laverieId: null,
    productId: null,
    ticketType: null,
    ticketStatus: null,
    description: "",
    errorCode: "",
    centralErrorCode: "",
    caller: "",
    telephone: "",
    email: "",
    concernedService: null,
    waterStatus: null,
    tapsStatus: null,
    productIsPluggedIn: null,
    drumTurns: null,
    coinSlotTakesCoins: null,
    clientCompany: "",
    callerType: null,
    contactType: null,
});

const ticketStatusItems = [
    { label: "Ouvert", value: SupportTicketStatus.OPEN },
    { label: "Assigné", value: SupportTicketStatus.ASSIGNED },
    { label: "En cours", value: SupportTicketStatus.IN_PROGRESS },
    { label: "Résolu", value: SupportTicketStatus.DONE },
    { label: "Rejeté", value: SupportTicketStatus.REJECTED },
];

const ticketTypeItems = [
    { label: "Problème technique", value: SupportTicketType.TECHNICAL_ISSUE },
    { label: "Demande de remboursement", value: SupportTicketType.REIMBURSEMENT_REQUEST },
    { label: "Demande générale", value: SupportTicketType.GENERAL_INQUIRY },
];

const concernedServiceItems = [
    { label: "Commercial", value: SupportTicketConcernedService.COMMERCIAL },
    { label: "Comptabilité", value: SupportTicketConcernedService.ACCOUNTING },
    { label: "Technique", value: SupportTicketConcernedService.TECHNICAL },
    { label: "Administration", value: SupportTicketConcernedService.ADMINISTRATION },
];

const clientTypes = [
    { label: "Manager", value: SupportTicketCallerType.MANAGER },
    { label: "Utilisateur", value: SupportTicketCallerType.USER },
    { label: "Prospect", value: SupportTicketCallerType.PROSPECT },
];

const contactTypes = [
    { label: "Téléphone", value: SupportTicketContactType.TELEPHONE },
    { label: "Email", value: SupportTicketContactType.EMAIL },
    { label: "App Mobile", value: SupportTicketContactType.MOBILE_APP },
];

const waterStatusItems = [
    { label: "Eau propre", value: SupportTicketWaterStatus.CLEAN_WATER },
    { label: "Eau sale", value: SupportTicketWaterStatus.DIRTY_WATER },
];

const tapsStatusItems = [
    { label: "Robinets ouverts", value: SupportTicketTapsStatus.OPEN_TAPS },
    { label: "Robinets fermés", value: SupportTicketTapsStatus.CLOSED_TAPS },
];

const booleanItems = [
    { label: "Oui", value: true },
    { label: "Non", value: false },
];

const selectedLaverie = computed(() => {
    if (!form.value.laverieId) {
        return null;
    }

    return laveries.value.find((item) => item.id === form.value.laverieId) ?? null;
});

const hasRequiredFields = computed(() => {
    return !!(
        form.value.ticketType &&
        form.value.caller.trim() &&
        form.value.telephone.trim() &&
        form.value.concernedService &&
        form.value.laverieId &&
        form.value.description.trim() &&
        form.value.callerType
    );
});

watch(
    () => form.value.laverieId,
    async (laverieId) => {
        if (!laverieId) {
            concernedProducts.value = [];
            form.value.productId = null;
            return;
        }

        try {
            concernedProducts.value = await getProductsByLaverieId(laverieId);
            if (form.value.productId && !concernedProducts.value.some((item) => item.id === form.value.productId)) {
                form.value.productId = null;
            }
        } catch (e) {
            concernedProducts.value = [];
            form.value.productId = null;
            // Ignore because it's handled in axios service
        }
    }
);

const save = async () => {
    if (!hasRequiredFields.value) {
        appStore.sendWarningNotice("Veuillez renseigner tous les champs obligatoires.");
        return;
    }

    loading.value = true;
    try {
        const payload = form.value;

        if (!ticketId.value) {
            const savedTicket = await postSupportTicket(payload);
            ticketId.value = savedTicket.id ?? null;
            appStore.sendSuccessNotice("Appel enregistré.");
        } else {
            await putSupportTicket(ticketId.value, payload);
            appStore.sendSuccessNotice("Appel mis à jour.");
        }
    } catch (e) {
        // Ignore because it's handled in axios service
    } finally {
        loading.value = false;
    }
};

const cancel = () => {
    router.back();
};

onMounted(async () => {
    try {
        loading.value = true;
        laveries.value = await getAllLaveries();
        users.value = await getAllUsers();

        const id = route.params.id as string | undefined;
        if (!id || id === "new") {
            form.value.creatorId = sessionStore.loggedUser?.id;
            title.value = "Nouveau ticket de support";
            return;
        }

        ticketId.value = id;
        title.value = "Édition du ticket de support";
        form.value = await fetchSupportTicketById(id);

        if (form.value.laverieId) {
            concernedProducts.value = await getProductsByLaverieId(form.value.laverieId);
        }
    } catch (e) {
        // Ignore because it's handled in axios service
    } finally {
        loading.value = false;
    }
});
</script>
